exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".rating-star[data-v-49d786ca]{margin-bottom:4px}.rating-star-on[data-v-49d786ca]{width:100%;height:14px;font-size:0;line-height:0;color:transparent}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-49d786ca","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/RatingStar.vue
// module id = 27
// module chunks = 0